const keyCodes = {
    enter: 'Enter',
};

export default keyCodes;
